"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CbdFilterOption = void 0;
const products_1 = require("@getgreenline/products");
const RangeFilterOption_1 = require("./RangeFilterOption");
class CbdFilterOption extends RangeFilterOption_1.RangeFilterOption {
    constructor() {
        super(...arguments);
        this.singleValueKey = products_1.MetaDataModels.MetaDataReservedKeys.CBD;
        this.minValueKey = products_1.MetaDataModels.MetaDataReservedKeys.MIN_CBD;
        this.maxValueKey = products_1.MetaDataModels.MetaDataReservedKeys.MAX_CBD;
    }
}
exports.CbdFilterOption = CbdFilterOption;
//# sourceMappingURL=CbdFilterOption.js.map